<div class="text-container">
  <span class="text-overflow">
    @if (activityItem.action !== ProjectViewActivityAction.Custom) {
      <strong>{{ activityItem.action | projectViewActivityAction | titlecase }}</strong>
    } @else {
      <strong class="text-overflow">{{ activityItem.details.alertName }}</strong>
    }
    @if (user?.firstName && user.lastName && activityItem.action !== ProjectViewActivityAction.Custom) {
      <span>
        by {{ user.firstName | titlecase }} {{ user.firstName === 'admin' ? '' : (user.lastName | titlecase) }}</span
      >
    }
  </span>
  <span class="subtext text-overflow">{{ subtext }}</span>
</div>

<span class="time-display">{{ activityItem.timestamp | timeAgo }}</span>
